// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"v7Gi8VW1J162K9MkU3jB1","title":"qyPDFthzsrCpIO_4gaamj","certification":"Y56T0vYVKdAcAUv8IGVPO"};